import { localMessagesStore } from './local';
import { supabaseMessagesStore } from './supabase';
import type { ChatMessage, MessageThread, AuthorType } from '@/types/messages';

// Default to Supabase for OAuth httpOnly cookie compatibility
// Can be overridden with VITE_MESSAGES_BACKEND=local for testing
const useSupabase = (import.meta as any).env?.VITE_MESSAGES_BACKEND !== 'local';
const primaryStore = useSupabase ? supabaseMessagesStore : localMessagesStore;

console.log('[messages-adapter] Using backend:', useSupabase ? 'Supabase (worker endpoints)' : 'localStorage');

export const messagesStore = {
  getThreadsByCoach(coachId: string): Promise<MessageThread[]> {
    return primaryStore.getThreadsByCoach(coachId);
  },
  getThreadsByClient(clientId: string): Promise<MessageThread[]> {
    return primaryStore.getThreadsByClient(clientId);
  },
  getThreadByPair(clientId: string, coachId: string): Promise<MessageThread | null> {
    return (primaryStore as any).getThreadByPair?.(clientId, coachId) ?? Promise.resolve(null);
  },
  getThread(id: string): Promise<MessageThread | null> {
    return primaryStore.getThread(id) as any;
  },
  createThread(clientId: string, coachId: string): Promise<MessageThread> {
    return primaryStore.createThread(clientId, coachId);
  },
  appendMessage(msg: ChatMessage): Promise<void> {
    return primaryStore.appendMessage(msg);
  },
  markRead(threadId: string, userType: AuthorType, userId: string, atISO?: string): Promise<void> {
    return primaryStore.markRead(threadId, userType, userId, atISO);
  },
  getUnreadCounts(target: { coachId?: string; clientId?: string }): Promise<number> {
    return primaryStore.getUnreadCounts(target);
  },
  getMessages(threadId: string): Promise<ChatMessage[]> {
    return primaryStore.getMessages(threadId);
  },
};
